<form *ngIf="mailAccountFormGroup" [formGroup]="mailAccountFormGroup">
  <div class="grid">
      <div class="col-4 input-field">
          <label for="name">Nombre</label>
          <input pInputText name="name" formControlName="name" d-form-field-error />
      </div>
      <div class="col-6 input-field">
        <label for="smtpFrom">Dirección de correo</label>
        <input pInputText name="smtpFrom" formControlName="smtpFrom" d-form-field-error />
      </div>
      <div class="col-2 input-field">
        <label for="allowMailboxViewer">Mostrar buzon</label>
        <p-inputSwitch id="allowMailboxViewer" formControlName="allowMailboxViewer" d-form-field-error />
      </div>
      <div class="col-6 input-field">
          <label for="username">Nombre de usuario</label>
          <input pInputText name="username" formControlName="username" d-form-field-error />
      </div>
      <div class="col-6 input-field">
          <label for="password">Contraseña</label>
          <input pInputText type="password" formControlName="password" autocomplete="new-password"
              d-form-field-error />
      </div>
      <div class="col-12">
          <div class="grid">
              <div class="col-2 input-field">
                  <label for="smtpEnabled"><b>Habilitar SMTP</b></label>
                  <p-inputSwitch id="smtpEnabled" formControlName="smtpEnabled" d-form-field-error  (onChange)="imapChecked($event, 'smtp')"/>
              </div>
              <div class="col-6 input-field" *ngIf="mailAccountFormGroup.get('smtpEnabled')?.value">
                  <label for="smtpHost">Host</label>
                  <input pInputText name="smtpHost" formControlName="smtpHost" d-form-field-error />
              </div>
              <div class="col-2 input-field" *ngIf="mailAccountFormGroup.get('smtpEnabled')?.value">
                  <label for="smtpPort">Puerto</label>
                  <input pInputText type="number" name="smtpPort" formControlName="smtpPort" d-form-field-error />
              </div>
              <div class="col-2 input-field" *ngIf="mailAccountFormGroup.get('smtpEnabled')?.value">
                  <label for="smtpUseSSL">Usar SSL</label>
                  <p-inputSwitch id="smtpUseSSL" formControlName="smtpUseSSL" d-form-field-error />
              </div>
          </div>
      </div>
      <div class="col-12">
          <div class="grid">
              <div class="col-2 input-field">
                  <label for="imapEnabled"><b>Habilitar IMAP</b></label>
                  <p-inputSwitch id="imapEnabled" formControlName="imapEnabled" d-form-field-error (onChange)="imapChecked($event, 'imap')" />
              </div>
              <div class="col-6 input-field" *ngIf="mailAccountFormGroup.get('imapEnabled')?.value">
                  <label for="imapHost">Host</label>
                  <input pInputText name="imapHost" formControlName="imapHost" d-form-field-error />
              </div>
              <div class="col-2 input-field" *ngIf="mailAccountFormGroup.get('imapEnabled')?.value">
                  <label for="imapPort">Puerto</label>
                  <input pInputText type="number" name="imapPort" formControlName="imapPort" d-form-field-error />
              </div>
              <div class="col-1 input-field" *ngIf="mailAccountFormGroup.get('imapEnabled')?.value">
                  <label for="imapUseSSL">Usar SSL</label>
                  <p-inputSwitch id="imapUseSSL" formControlName="imapUseSSL" d-form-field-error />
              </div>
              <div class="col-1 input-field" *ngIf="mailAccountFormGroup.get('imapEnabled')?.value">
                  <label for="enableMailToCaseImport">Enlazar expedientes</label>
                  <p-inputSwitch id="enableMailToCaseImport" formControlName="enableMailToCaseImport" d-form-field-error />
              </div>
          </div>
      </div>
      <div class="col-12 input-field">
        <label for="isSystem">Cuenta de sistema</label>
        <p-inputSwitch id="isSystem" formControlName="isSystem" d-form-field-error />
        <small class="block mt-1 text-color-secondary" *ngIf="mailAccountFormGroup.get('isSystem')?.value && currentSystemMailAccountName">
          <i class="pi pi-exclamation-triangle text-orange-500 mr-1"></i>
          Actualmente la cuenta de sistema es «{{currentSystemMailAccountName}}». Al guardar, pasará a serlo esta.
        </small>
      </div>
  </div>
  <div class="mt-4 flex gap-2">
      <p-button label="Eliminar" icon="pi pi-trash" styleClass="p-button-danger" (click)="delete()" *ngIf="mailAccount.id && allowDelete"></p-button>
      <div class="flex-grow"></div>
      <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
      <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-save"  (click)="save()"></p-button>
  </div>
</form>